import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS} from 'utils/constants';
import { addPortalSuccess, saveContactFailed } from '../actions';
import { ContactActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* saveContact({ data }) {
  const url = `${API_BASE_URL}/organisation/contacts`;

  const response = yield request({
    method: 'post',
    data: data,
    url,
  });
  if (response.success) {
    yield put(addPortalSuccess(response.raw));
    Notify('Contact Information Saved Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    yield put(saveContactFailed(response.message));
    const message = response.statusCode === 400 ? 'One or more email is in the wrong format' : response.message; 

    networkErrorHandler(response?.statusCode, message);
  }
}

export function* saveContactSettings() {
  yield takeLatest(ContactActionTypes.SAVE_CONTACT, saveContact);
}
